module.exports = __webpack_public_path__ + "static/media/style2-1.cef4f582.gif";